import * as React from 'react';
import {
  TPAComponentsWrapper,
  createRendererWithUniDriver,
} from '../../test/utils';
import { textButtonDriverFactory } from './TextButton.driver';
import { TextButtonPriority, TextButton } from '.';

describe('TextButton', () => {
  const render = createRendererWithUniDriver(textButtonDriverFactory);

  it('should render', async () => {
    const value = 'Hello';
    const { driver } = render(<TextButton>{value}</TextButton>);
    expect(await driver.exists()).toBe(true);
    expect(await driver.getButtonTextContent()).toEqual(value);
  });

  it('should use mobile design', async () => {
    const { driver } = render(
      TPAComponentsWrapper({ mobile: true })(
        <TextButton data-hook="text-button" />,
      ),
      'text-button',
    );
    expect(await driver.isMobile()).toBe(true);
  });

  it('should set priority', async () => {
    const { driver } = render(
      <TextButton priority={TextButtonPriority.primary} />,
    );
    expect(await driver.hasPriority(TextButtonPriority.primary)).toBe(true);
  });
});
